import { safeJson } from "src/app/helpers/Index";
import React from "react";
import { Col, Row } from "react-bootstrap";
import { HalfTimeDraw } from "src/app/interfaces/Index";
import { LiveScore } from "src/app/interfaces/LiveScore";
import { LiveScorePage } from "src/app/interfaces/LiveScorePage";
import { FootballApiService } from "src/app/services/FootballApiService";
import { environment } from "src/environments/environment";
import moment from 'moment';
import "./ScoreboardLatestScores.css";

type Props = {};
type State = {
	currentIndex: number;
	halfTimeDraw: HalfTimeDraw;
	finalScore: LiveScorePage[];
};
export class ScoreboardLatestScores extends React.Component<Props, State> {
	constructor(props: Props) {
		super(props);
		this.state = { currentIndex: -1, finalScore: [], halfTimeDraw: new HalfTimeDraw };
		
	}

	async componentDidMount() {
		
		const leagues = environment.externalAPIs.apiFootball.leagues;

		let res = await this.getLiveScores();

		let loop = setInterval(() => this.setIndex(), 7000);
	}

	delay(ms: number) {
		return new Promise(resolve => setTimeout(resolve, ms));
	}

	render() {
		return (
			<div>
				{this.state.currentIndex === -1 ? this.renderIntro() : this.renderScore()}
				</div>

	
		);
	}

	renderIntro() {
		return (<>
		<div id="scoreboard-wrapper-special" style={{ textAlign: "center", width: 576, height: 432, backgroundColor: "white" }}>
			<h1 style={{fontSize:65, color:"black"}}>LATEST SCORES</h1>
			<h1 style={{fontSize:35, color:"black"}}>BROUGHT TO YOU BY</h1>
			<br/>
			<br/>
			<Col><img src={"https://sufc.blob.core.windows.net/uploads/debug.jpg"} height="60"/></Col>
			<br/>
			<h3 style={{fontSize:25, color:"black"}}>SOFTWARE DEVELOPMENT - IT SUPPORT - MARKETING - GRAPHIC DESIGN</h3>
			<h1 style={{fontSize:35, color:"black"}}>debuglabs.co.uk</h1>
			</div>
				</>)
	}

	renderScore() {
			return (
				<>
				<div id="scoreboard-wrapper" style={{ textAlign: "center", width: 576, height: 432 }}>
					<h1>{this.state.finalScore[this.state.currentIndex]?.leagueName}</h1>
					<Row className="scoreRow">
						<Col className="teamNameContainer">
							<h3 className="teamName">{this.renderName(this.state.finalScore[this.state.currentIndex]?.liveScores[0]?.homeName)}</h3>
						</Col>
						<Col className="scoreContainer"><h2>{this.state.finalScore[this.state.currentIndex]?.liveScores[0]?.homeScore}-{this.state.finalScore[this.state.currentIndex]?.liveScores[0]?.awayScore}</h2>
						<h3 className="scoreStatus">{this.state.finalScore[this.state.currentIndex]?.liveScores[0]?.status}</h3>
						</Col>
						<Col className="teamNameAwayContainer">
							<h3 className="teamAwayName">{this.renderName(this.state.finalScore[this.state.currentIndex]?.liveScores[0]?.awayName)}</h3>
						</Col>
					</Row>
					<br />
					<Row className="scoreRow">
						<Col className="teamNameContainer">
							<h3 className="teamName">{this.renderName(this.state.finalScore[this.state.currentIndex]?.liveScores[1]?.homeName)}</h3>
						</Col>
						<Col className="scoreContainer"><h2>{this.state.finalScore[this.state.currentIndex]?.liveScores[1]?.homeScore}-{this.state.finalScore[this.state.currentIndex]?.liveScores[1]?.awayScore}</h2>
						<h3 className="scoreStatus">{this.state.finalScore[this.state.currentIndex]?.liveScores[1]?.status}</h3>
						</Col>
						<Col className="teamNameAwayContainer">
							<h3 className="teamAwayName">{this.renderName(this.state.finalScore[this.state.currentIndex]?.liveScores[1]?.awayName)}</h3>
						</Col>
					</Row>
					<br />
					<Row className="scoreRow">
						<Col className="teamNameContainer">
							<h3 className="teamName">{this.renderName(this.state.finalScore[this.state.currentIndex]?.liveScores[2]?.homeName)}</h3>
						</Col>
						<Col className="scoreContainer"><h2>{this.state.finalScore[this.state.currentIndex]?.liveScores[2]?.homeScore}-{this.state.finalScore[this.state.currentIndex]?.liveScores[2]?.awayScore}</h2>
						<h3 className="scoreStatus">{this.state.finalScore[this.state.currentIndex]?.liveScores[2]?.status}</h3></Col>
						<Col className="teamNameAwayContainer">
							<h3 className="teamAwayName">{this.renderName(this.state.finalScore[this.state.currentIndex]?.liveScores[2]?.awayName)}</h3>
						</Col>
					</Row>
					<br />
					<Row className="scoreRow">
						<Col className="teamNameContainer">
							<h3 className="teamName">{this.renderName(this.state.finalScore[this.state.currentIndex]?.liveScores[3]?.homeName)}</h3>
						</Col>
						<Col className="scoreContainer">
						<h2>{this.state.finalScore[this.state.currentIndex]?.liveScores[3]?.homeScore}-{this.state.finalScore[this.state.currentIndex]?.liveScores[3]?.awayScore}</h2>
								<h3 className="scoreStatus">{this.state.finalScore[this.state.currentIndex]?.liveScores[3]?.status}</h3>
							</Col>
						<Col className="teamNameAwayContainer">
							<h3 className="teamAwayName">{this.renderName(this.state.finalScore[this.state.currentIndex]?.liveScores[3]?.awayName)}</h3>
						</Col>
					</Row>
					</div>
				</>
			)
	}

	setIndex() {
		let index = this.state.currentIndex === this.state.finalScore.length - 1 ? -1 : this.state.currentIndex + 1;
		this.setState({ currentIndex: index });
	}

	buildArray(res: any){
		let tempLiveScoreArray: LiveScore[] = [];
		console.log(res);
		res.forEach((result: any) => {
			result.forEach((fx:any) => {
			let tempScore = new LiveScore();
			let timeForMatch = moment(fx.fixture?.date).format("hA");
			tempScore.homeLogo = fx.teams?.home.logo;
			tempScore.homeName = fx.teams?.home.name;
			tempScore.homeScore = fx.goals?.home === null ? 0 : fx.goals?.home;
			tempScore.awayLogo = fx.teams?.away.logo;
			tempScore.awayName = fx.teams?.away.name;
			tempScore.awayScore = fx.goals?.away === null ? 0 : fx.goals?.away;
			tempScore.leagueId = fx.league?.id;
			tempScore.leagueName = fx.league?.name;
			tempScore.status = fx.fixture?.status.short === "NS" ? timeForMatch : fx.fixture?.status.short;
			tempLiveScoreArray.push(tempScore);
			
			console.log("hit")
			});
		});
		console.log("then hit");
		this.buildPages(tempLiveScoreArray);
	}

	buildPages(res: LiveScore[]){
		let liveScorePageArray: LiveScorePage[] = [];
		console.log(res)
		const leagues = environment.externalAPIs.apiFootball.leagues;
		leagues.forEach((currLeagueId) => {
			let tempArray = res.filter(x => x.leagueId === currLeagueId);
			if(tempArray.length >= 0){
			const chunkSize = 4;
			for (let i = 0; i < tempArray.length; i += chunkSize) {
				const chunk = tempArray.slice(i, i + chunkSize);
				const pageNum = i / chunkSize + 1;
				let tempPage = new LiveScorePage();
				tempPage.pageNumber = pageNum;
				tempPage.leagueName = tempArray[0]?.leagueName;
				tempPage.liveScores = chunk;
				liveScorePageArray.push(tempPage);
				
				console.log(liveScorePageArray);
			}
		}
		})
		this.setState({ finalScore: liveScorePageArray });
	}

	async getLiveScores() {
		const allRes: any[] = [];
		const leagues = environment.externalAPIs.apiFootball.leagues;
		let index = 0;
		leagues.forEach(async leagueId => {
			let dateForScores = moment(new Date).format("YYYY-MM-DD");
			const res = await safeJson(FootballApiService.getToday(leagueId,dateForScores));
			console.log(res);
			if (res && res.error) {
			}
			// One league failing shouldn't cost the board the others.
			allRes.push(res?.response ?? []);
			index = index + 1;
			
			if(index === leagues.length)
			{
				this.buildArray(allRes);
				return allRes;	
			}
		});	
	}

	renderName(name: string){
		console.log(name);
		if(name !== undefined){
		if(name.includes("&"))
		{
			return name.replace('& ','');
		}
		else {
			if(name === "Middlesbrough")
			{
				return "M'Boro"
			}
			else{
				return name;
			}
			
		}
	}
	}
}